import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CourseEmployeeFiltersFormT } from 'types';
import useTerminalsApi from 'Hooks/useTerminalsApi';
import useDepartmentsApi from 'Hooks/useDepartmentsApi';
import useJobTitlesApi from 'Hooks/useJobTitlesApi';
import useDebounce from 'Hooks/useDebounce';
import { useEffect } from 'react';
import {
  CourseEmployeeFiltersFormSchema,
  defaultCourseEmployeeFiltersFormValues,
} from '../schemas/course-employee-filters-form-schema';

interface Props {
  onSearch: (values: CourseEmployeeFiltersFormT) => void;
}

const useCoursesLessonsFilters = ({ onSearch }: Props) => {
  // Formulario para los filtros
  const {
    control,
    register,
    handleSubmit,
    formState: { errors, isDirty },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm<CourseEmployeeFiltersFormT>({
    defaultValues: defaultCourseEmployeeFiltersFormValues,
    resolver: zodResolver(CourseEmployeeFiltersFormSchema),
  });

  // Terminales
  const { data: terminals } = useTerminalsApi({
    init: true,
  });

  // Departamentos
  const { data: departments } = useDepartmentsApi({
    init: true,
  });

  // Puestos
  const { data: jobTitles } = useJobTitlesApi({
    init: true,
  });

  // Resetear filtros
  const onResetFilters = () => {
    reset(defaultCourseEmployeeFiltersFormValues);
    onSearch({});
  };

  // Debounce para los filtros
  const fullName = watch('fullName');
  const debouncedFullName = useDebounce(fullName, 500);

  useEffect(() => {
    if (debouncedFullName !== undefined) {
      const values = Object.fromEntries(
        Object.entries(getValues()).filter(([_, value]) => value !== undefined && value !== '')
      ) as CourseEmployeeFiltersFormT;
      onSearch(values);
    }
  }, [debouncedFullName]);

  return {
    control,
    register,
    handleSubmit,
    errors,
    getValues,
    setValue,
    terminals,
    departments,
    jobTitles,
    isDirty,
    onResetFilters,
  };
};

export default useCoursesLessonsFilters;
